
import { useState, useEffect, useRef } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronUp } from 'lucide-react';

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ticking = useRef(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (!ticking.current) {
        requestAnimationFrame(() => {
          // Use scrollY instead of pageYOffset to avoid forced reflows
          setIsVisible(window.scrollY > 300);
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      onClick={scrollToTop}
      className="fixed bottom-8 right-32 z-50 h-12 w-12 rounded-full bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-green-500/30"
      size="icon"
    >
      <ChevronUp className="h-6 w-6" />
    </Button>
  );
};
